import { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
function useOrientation() {
    var _a = useState(window.matchMedia('(orientation: landscape)').matches && isMobile), isLandscape = _a[0], setIsLandscape = _a[1];
    var updateOrientation = function () {
        setIsLandscape(window.matchMedia('(orientation: landscape)').matches && isMobile);
    };
    useEffect(function () {
        window.addEventListener('resize', updateOrientation);
        return function () {
            window.removeEventListener('resize', updateOrientation);
        };
    }, []);
    return isLandscape;
}
export default useOrientation;
